import React from 'react';
import About from '../components/About';
import PageSeo from '../components/shared/PageSeo';
import { PAGE_SEO } from '../data/seo';

const AboutPage = () => (
  <>
    <PageSeo {...PAGE_SEO.about} />
    <About />
  </>
);

export default AboutPage;
